var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": "80%"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_vm.data ? _c('div', {
    staticClass: "popReward"
  }, [_vm.data.count > 0 ? [_c('div', {
    staticClass: "popReward__title"
  }, [_vm._v("Congratulations")]), _c('div', {
    staticClass: "popReward__reward"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/niceLucky/icon-ship.png`),
      "alt": ""
    }
  }), _vm._v(" +" + _vm._s(_vm.fmt_pre(_vm.data.count)) + " ")]), _c('div', {
    staticClass: "popReward__balance"
  }, [_vm._v(" NFT Shards: "), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/niceLucky/icon-ship.png`),
      "alt": ""
    }
  }), _c('span', [!_vm.isBalanceChange ? [_vm._v(" " + _vm._s(_vm.fmt_pre(_vm.data.balance)) + " ")] : _c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.data.newBalance),
      "duration": 1
    }
  })], 2)])] : [_c('div', {
    staticClass: "popReward-fail"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/CRY.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "popReward-fail__sub"
  }, [_vm._v("make persistent efforts")])])], _c('div', {
    staticClass: "btn-confirm",
    on: {
      "click": _vm.confirmFn
    }
  }, [_vm._v("OK")])], 2) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };